import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Global constants — change these in ONE place
export const CALENDLY_URL = 'https://calendly.com/hello-eb-agency/30min';
export const LOGO_URL = '/images/logo.png';
export const CONTACT_EMAIL = 'hello@eb-agency.com';
export const WEB3FORMS_ACCESS_KEY = 'bdb474ac-c1bb-451d-9f06-0ebda0568b67';
